import {OrderPlaceTabType} from '@px/enum/order';
import {CalculatorTabType} from '@px/enum/tab-pc';
import {OrderBookType} from '@px/enum/book';
import {PlaceOrderSide} from '@px/enum';
import {storageUtil} from '@px/helper/storage';

interface Pos {
  x: number;
  y: number;
}

interface MarginStorage extends StorageObject {
  calculatorDialogPos: Pos;
  calculatorTabType: CalculatorTabType;
  placeOrderSide: PlaceOrderSide;
  placeOrderTabType: OrderPlaceTabType;
  orderBookType: OrderBookType;
  advancedIsShow: boolean;
  hideOtherSymbols: boolean;
  lastSymbol: string;
  guideStep: string;
}

const STORAGE_KEY = 'margin_trade_storage';

export const marginStorage = {
  readMarginStorage(): MarginStorage {
    return storageUtil.readStorageObject(STORAGE_KEY, createInitSpotStorage());
  },
  updateMarginStorage(kv) {
    storageUtil.writeStorageObject(STORAGE_KEY, {...marginStorage.readMarginStorage(), ...kv});
  },
};

function createInitSpotStorage(): MarginStorage {
  return {
    version: 1,
    calculatorDialogPos: null,
    calculatorTabType: CalculatorTabType.ProfitLoss,
    placeOrderSide: PlaceOrderSide.Right,
    placeOrderTabType: OrderPlaceTabType.Limit,
    orderBookType: OrderBookType.Stack,
    advancedIsShow: false,
    hideOtherSymbols: false,
    lastSymbol: '',
    guideStep: 'transfer',
  };
}
